import {store} from '../../utilities'
import {setActive} from '../../action_creators'

export default function onOk() {
  const state = store.getState()
  // const {failures} = state

  store.dispatch(setActive('create'))
}
